<template>
  <v-layout row wrap>
    <v-flex sm12>
      <div class="details-layout__menu" >
        <span class="menu-item">
          <router-link :to="{ name: 'houseDetailInfo' }">
            Details
          </router-link>
        </span>
        <span class="menu-item">
          <router-link :to="{ name: 'houseDetailFee' }">
            Expenses
          </router-link>
        </span>
        <span class="menu-item">
          <v-menu>
            <template v-slot:activator="{ on }">
              <a v-on="on">
                Lease
                <v-icon>arrow_drop_down</v-icon>
              </a>
            </template>
            <v-list>
              <v-list-tile v-for="(lease, key) in leases" :key="key">
                <v-list-tile-title>
                  <router-link :to="{ name: 'houseDetailLeasesInfo', params: { id: lease.id } }">
                    {{ getLeaseTitle(lease) }}
                  </router-link>
                </v-list-tile-title>
              </v-list-tile>
              <v-divider />
              <v-list-tile >
                <v-list-tile-title  style="height: 4rem; padding-top: .4rem;">
                  <router-link :to="{ name: 'houseDetailLeaseAdd' }" class="v-btn theme--light primary">
                    <v-icon color="white">add</v-icon>
                    Add Lease
                  </router-link>
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>

        </span>
        <span class="menu-item">
          <router-link :to="{ name: 'houseDetailReport' }">
            Report
          </router-link>
        </span>
        <span class="menu-item">
          <router-link :to="{ name: 'inspectionTasks', params: { id: 0 } }">
            Inspections
          </router-link>
        </span>
        <span class="menu-item">
          <router-link :to="{ name: 'hhsTasks', params: { id: 0 } }">
            HHS
          </router-link>
        </span>
        <span class="menu-item">
          <router-link :to="{ name: 'maintenanceTasks', params: { id: 0 } }">
            Maintenance
          </router-link>
        </span>
      </div>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'DetailsMenu',
  computed: {
    ...mapGetters({
      leases: 'HouseList/Lease/getAll'
    })
  },
  methods: {
    getLeaseTitle(lease) {
      return 'Lease '
        + moment(lease.checkin_date).format('MM/YY')
        + ' - '
        + moment(lease.checkout_date).format('MM/YY')
    }
  }
}
</script>
